/**
 * @generated SignedSource<<464d95b9bc074281bddb84a990f89114>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersRecruitIncentiveTypeChoices = "CA" | "EX" | "PT" | "%future added value";
export type ScreenersRecruitStatusChoices = "F" | "NS" | "P" | "S" | "%future added value";
export type StartRecruitInput = {
  clientMutationId?: string | null;
  recruitId: string;
};
export type RecruitDetails_startRecruit_Mutation$variables = {
  input: StartRecruitInput;
};
export type RecruitDetails_startRecruit_Mutation$data = {
  readonly startRecruit: {
    readonly recruit: {
      readonly completedScreenerCount: number | null;
      readonly id: string;
      readonly incentive: string | null;
      readonly incentivePoints: number | null;
      readonly incentiveType: ScreenersRecruitIncentiveTypeChoices | null;
      readonly invitesSentCount: number | null;
      readonly overNeedsReviewLimit: boolean | null;
      readonly qualifiedCount: number | null;
      readonly recruitPersonCount: number | null;
      readonly status: ScreenersRecruitStatusChoices;
      readonly underGoal: boolean | null;
    } | null;
  } | null;
};
export type RecruitDetails_startRecruit_Mutation = {
  response: RecruitDetails_startRecruit_Mutation$data;
  variables: RecruitDetails_startRecruit_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartRecruitPayload",
    "kind": "LinkedField",
    "name": "startRecruit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitNode",
        "kind": "LinkedField",
        "name": "recruit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invitesSentCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitPersonCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedScreenerCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "qualifiedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overNeedsReviewLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "underGoal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incentiveType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incentivePoints",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incentive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitDetails_startRecruit_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitDetails_startRecruit_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "149493698b23ff32be71557554cc12b7",
    "id": null,
    "metadata": {},
    "name": "RecruitDetails_startRecruit_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitDetails_startRecruit_Mutation(\n  $input: StartRecruitInput!\n) {\n  startRecruit(input: $input) {\n    recruit {\n      id\n      status\n      invitesSentCount\n      recruitPersonCount\n      completedScreenerCount\n      qualifiedCount\n      overNeedsReviewLimit\n      underGoal\n      incentiveType\n      incentivePoints\n      incentive\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "812532a8a76a9214a3a184ede1018cf4";

export default node;
